export interface MediaSessionResources {
  stream?: MediaStream;
  peer?: RTCPeerConnection;
  retryTimer?: number;
}

export function releaseMediaSession(
  resources: MediaSessionResources,
  clearTimer: (timer: number) => void = window.clearTimeout
): void {
  if (resources.retryTimer !== undefined) clearTimer(resources.retryTimer);
  resources.peer?.close();
  resources.stream?.getTracks().forEach((track) => track.stop());
}
